import { atom } from "recoil";

const sidebarAtom = atom<boolean>({
    key: 'sidebarState',
    default: false
  });
  
  export { sidebarAtom };